import { Component, computed, input, output } from '@angular/core';
import { MapUiComponent } from '../../default-map/map-ui/map-ui.component';
import { LocationsSkeletonService } from '../../../locations-skeleton.service';
import { createLocationMarkers, CvMarkerType, MapMarkerData, MAX_ZOOM } from '../../map-utils';
import { GxInputDirective } from '../../../../../directives/gxinput.directive';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { Location } from '../../../../../models/locations-models/location';
import { CvMapService } from '../cv-map.service';

@Component({
  selector: 'app-cv-map-ui',
  imports: [
    GxInputDirective,
    MatButton,
    MatCheckbox,
    MatDivider,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    MatPrefix,
    MatSuffix,
    NgClass,
  ],
  templateUrl: './cv-map-ui.component.html',
  styleUrls: ['./cv-map-ui.component.scss', '../../default-map/map-ui/map-ui.component.scss'],
})
export class CvMapUiComponent extends MapUiComponent {
  public focusedLocation = input.required<Location>();
  public customMarker = input.required<MapMarkerData>();
  public showValidationHistoryActive = input.required<boolean>();
  public continueAfterValidationActive = input.required<boolean>();
  public canContinueAfterValidation = input.required<boolean>();
  public streetViewClosedByUser = input.required<boolean>();

  private readonly locationMarkers = computed(() => createLocationMarkers(this.focusedLocation()));

  protected readonly gMarker = computed(() => this.locationMarkers()
      ?.find(m => m.type === CvMarkerType.GEOCODE));
  protected readonly iMarker = computed(() => this.locationMarkers()
      ?.find(m => m.type === CvMarkerType.IMPORT));
  protected readonly canPlaceCustomMarker = computed(() =>
      !!this.focusedLocation() && !this.customMarker());
  protected readonly canFocusCustomMarker = computed(() =>
      !!this.focusedLocation() && !!this.customMarker());


  protected readonly placeCustomCvMarker = output<MapMarkerData>();
  protected readonly continueAfterValidation = output<boolean>();
  protected readonly showValidationHistory = output<boolean>();

  constructor(protected skeletonService: LocationsSkeletonService,
              private cvMap: CvMapService) {
    super(skeletonService);
  }

  protected onCenterMarker(marker: MapMarkerData) {
    this.googleMap().googleMap.setCenter(marker.position);
    this.googleMap().googleMap.setZoom(MAX_ZOOM - 2);
    this.cvMap.centerStreetViewPosition([marker], this.streetViewClosedByUser()).then();
  }

  protected onPlaceCustomMarker() {
    this.placeCustomCvMarker.emit({
      id: CvMarkerType.CUSTOM,
      type: CvMarkerType.CUSTOM,
      position: this.googleMap().googleMap.getCenter().toJSON(),
    });
  }

  protected onContinueAfterValidationClick(e: MatCheckboxChange) {
    this.continueAfterValidation.emit(e.checked);
  }

  protected onShowHistoryClick() {
    this.showValidationHistory.emit(!this.showValidationHistoryActive());
  }
}
